<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <h3>Territory Managers</h3>
      </v-flex>

      <v-flex md12 lg5>
        <p>Options by Creator -- (* for Affiliates)</p>
        <v-data-table
          :headers="headers"
          :items="creatorData"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}<span v-if="props.item.isAffiliate">*</span></td>
            <td>{{ props.item.total }}</td>
            <td>{{ props.item.accepted }}</td>
            <td>{{ props.item.amAccepted }}</td>
            <td>{{ parseInt(props.item.averageDuration) }}</td>
          </template>
        </v-data-table>
      </v-flex>

      <v-flex md12 lg5 offset-lg1>
        <p>Options by Industry</p>
        <v-data-table
          :headers="headers"
          :items="industryData"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.total }}</td>
            <td>{{ props.item.accepted }}</td>
            <td>{{ props.item.amAccepted }}</td>
            <td>{{ parseInt(props.item.averageDuration) }}</td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'TmTable',
  props: ['creatorData', 'industryData'],
  data() {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Options',
          value: 'total'
        },
        {
          text: 'Accepted',
          value: 'accepted'
        },
        {
          text: 'AM Accepted',
          value: 'amAccepted'
        },
        {
          text: 'Average Duration (minutes)',
          value: 'averageDuration'
        }
      ]
    };
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reports/options/TmTable.vue